
import { X } from 'lucide-react';

const PreviewHeader = ({ onClose, isMetaCampaign }) => {
  if (isMetaCampaign) {
    return (
      <div className="py-3 px-6 bg-white">
        <div className="flex items-center justify-between">
          <div className="flex-1"></div>
          <div className="flex items-center gap-4">
            <h2 className="text-sm sm:text-base font-semibold text-gray-900">Así se van a ver tus anuncios 🎉</h2>
          </div>
          <div className="flex-1 flex justify-end">
            {onClose && (
              <button
                onClick={onClose}
                className="rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900"
              >
                <X className="w-4 h-4 sm:w-5 sm:h-5" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

      return (
      <div className="py-3 px-6 bg-white">
      <div className="flex items-center justify-between">
        <h2 className="text-sm sm:text-base font-semibold text-gray-900">Preview de tu campaña</h2>
        <div className="flex ">
          {onClose && (
            <button
              onClick={onClose}
              className="rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900"
            >
              <X className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewHeader;